<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-data-table
          :headers="headersEvidences"
          :items="data.evidences"
          :items-per-page="20"
          no-data-text="No hay registro"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                dark
                class="mb-2"
                @click="add"
                v-if="false"
              >
                Agregar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.actions`]="item">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-1"
                  @click="download(item.item.file_url)"
                >
                  mdi-cloud-download
                </v-icon>
              </template>
              <span>Descargar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="red"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-1"
                  @click="deleteEvidence(item.item.id)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- delete dialog -->
    <v-dialog v-model="dialogAdd" width="500" persistent>
      <v-card>
        <v-card-title> Agregar Evidencia </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="py-1">
          <v-form ref="form" v-model="form">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="model.name"
                    label="Nombre"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                    label="Documento"
                    v-model="model.file"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>
          <v-btn color="blue darken-1" text @click="save"> Guardar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- delete dialog -->
    <v-dialog v-model="dialogDelete" width="500" persistent>
      <v-card>
        <v-card-text class="py-4">
          Seguro que desea eliminar esta evidencia?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" class="mr-4" @click="deleteConfirmed" small>
            Confirmar
          </v-btn>

          <v-btn
            color="error"
            text
            class="mr-4"
            @click="dialogDelete = false"
            small
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SET_ALERT } from "@/store/alert";
export default {
  name: "Evidences",
  props: {
    data: {
      required: true,
    },
  },
  data: () => ({
    form: true,
    current: null,
    dialogAdd: false,
    dialogDelete: false,
    headersEvidences: [
      {
        text: "Nombre",
        value: "name",
        sortable: true,
      },
      {
        text: "Acciones",
        value: "actions",
        filterable: false,
        sortable: false,
      },
    ],
    model: {
      name: "",
      file: null,
    },
  }),
  methods: {
    download(url) {
      window.open(url, "_blank");
    },
    add() {
      this.dialogAdd = true;
    },
    close() {
      this.dialogAdd = false;
      this.$nextTick(() => {
        this.model = {
          name: "",
          file: null,
        };
        this.$refs.form.resetValidation();
      });
    },
    save() {
      //Validate inputs
      if (this.model.name == "" || typeof this.model.file !== "object") {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      this.model.report_id = this.data.id;
      this.$store.dispatch("createEvidence", this.createFormData());
      this.close();
    },
    deleteEvidence(id) {
      this.current = id;
      this.dialogDelete = true;
    },
    deleteConfirmed() {
      this.$store.dispatch("deleteEvidence", this.current);
      this.dialogDelete = false;
    },
    createFormData() {
      let formData = new FormData();
      Object.entries(this.model).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((element, index) => {
            Object.entries(element).forEach(([keyEvidence, valueEvidence]) => {
              formData.append(
                key + "[" + index + "]" + "[" + keyEvidence + "]",
                valueEvidence
              );
            });
          });
        } else {
          formData.append(key, value);
        }
      });
      return formData;
    },
  },
};
</script>
